<template>
  <header id="header" class="header fixed-top" data-scrollto-offset="0">
    <div class="container-fluid d-flex align-items-center justify-content-between">
      <div class="logoDiv"><router-link to="/" class="d-flex align-items-center me-auto me-lg-0"><img alt="logo" v-bind:src="logoMain"></router-link></div>
      <div class="header-end d-flex align-items-center">
      <nav id="navbar" class="navbar">
        <ul>
          <li class="dropdown"> <router-link to="/About#ict"><span>{{ $t('navibar1') }}</span> <i class="bi bi-chevron-down dropdown-indicator"></i></router-link>
            <ul>
              <li><router-link to="/About#AboutICT"       class="nav-link scrollto">{{ $t('navibar1_1') }}</router-link></li>
              <li><router-link to="/About#AboutPSA"       class="nav-link scrollto">{{ $t('navibar1_2') }}</router-link></li>
              <li><router-link to="/About#AboutVideo"     class="nav-link scrollto">{{ $t('navibar1_3') }}</router-link></li>
              <li><router-link to="/About#AboutCEO"       class="nav-link scrollto">{{ $t('navibar1_4') }}</router-link></li>
              <li><router-link to="/About#AboutHistory"   class="nav-link scrollto">{{ $t('navibar1_5') }}</router-link></li>
              <li><router-link to="/About#AboutCondition" class="nav-link scrollto">{{ $t('navibar1_6') }}</router-link></li>
              <li><router-link to="/About#AboutCode"   class="nav-link scrollto">{{ $t('navibar1_7') }}</router-link></li>
              <li><router-link to="/About#AboutPolicy"    class="nav-link scrollto">{{ $t('navibar1_8') }}</router-link></li>
            </ul>
          </li>
          <li class="dropdown"><router-link to="/Schedule"><span>{{ $t('navibar2') }}</span> <i class="bi bi-chevron-down dropdown-indicator"></i></router-link>
            <ul>
              <li><router-link to="/Schedule"        >{{ $t('navibar2_1') }}</router-link></li>
              <li><router-link to="/EmptyContainer"  >{{ $t('navibar2_2') }}</router-link></li>
              <li><router-link to="/EmptyInTime"     >{{ $t('navibar2_7') }}</router-link></li>
              <li><router-link to="/VesselWorkStatus">{{ $t('navibar2_3') }}</router-link></li>
              <li><router-link to="/YardWorkStatus"  >{{ $t('navibar2_4') }}</router-link></li>
              <li><router-link to="/Container"       >{{ $t('navibar2_5') }}</router-link></li>
              <li><router-link to="/Vessel"          >{{ $t('navibar2_6') }}</router-link></li>
              <li><router-link to="/CopinoSend"      >{{ $t('navibar2_8') }}</router-link></li>
            </ul>
          </li>
          <li class="dropdown"><router-link to="/Notice/SUBJECT"><span>{{ $t('navibar3') }}</span> <i class="bi bi-chevron-down dropdown-indicator"></i></router-link>
            <ul>
              <li><router-link to="/Notice/SUBJECT">{{ $t('navibar3_1') }}</router-link></li>
              <li><router-link to="/Tender/SUBJECT">{{ $t('navibar3_2') }}</router-link></li>
              <li><router-link to="/Recruit/SUBJECT">{{ $t('navibar3_3') }}</router-link></li>
              <li><router-link to="/Reference/SUBJECT">{{ $t('navibar3_4') }}</router-link></li>
              <li><router-link to="/Ethicalmanagement">{{ $t('navibar3_5') }}</router-link></li>
              <li><router-link to="/FAQ">{{ $t('navibar3_7') }}</router-link></li>
              <li><router-link to="/Contact">{{ $t('navibar3_8') }}</router-link></li>
            </ul>
          </li>
          <li><a href="https://service.psa-ict.co.kr">{{ $t('navibar4') }}</a></li>
            <li class="dropdown"><a><i class="bi bi-translate"></i><i class="bi bi-chevron-down dropdown-indicator"></i></a>
            <ul id="dropdownMenu">
                <li><a href="#" @click="changeKorean">Korean</a></li>
                <li><a href="#" @click="changeEnglish">English</a></li>
            </ul>
          </li>
        </ul>
        <i class="bi bi-list mobile-nav-toggle d-none"></i>
      </nav><!-- .navbar -->
      <a class="globalLogoLink" href="http://www.globalpsa.com" target="_blank"><img class="globalLogo" v-bind:src="logoGlobal"></a>
      </div>
  </div>
  </header>
</template>
<script src="@/assets/js/Common/NaviBar.js"></script>

<style scoped>
.logoDiv{
  display: flex;
  align-items: center;
  height: 100%;
  width: auto;
  flex-shrink: 0;
}
.logoDiv a{
  display: flex;
  align-items: center;
  height: 100%;
}
.logoDiv img{
  width: 270px;
  height: auto;
  max-width: none;
  object-fit: contain;
  display: block;
  transform: translateY(-7px);
  transition: width 0.25s ease-in-out;
}
.header-end{
  gap: 12px;
}
.globalLogoLink{
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.globalLogo{
  height: 23px;
  width: auto;
  display: block;
  object-fit: contain;
}
#dropdownMenu{
  left: -170%;
}
.header{
  height: 120px;
  padding: 15px 0;
  box-sizing: border-box;
  background: #fff;
  transition: height 0.25s ease-in-out, padding 0.25s ease-in-out, box-shadow 0.25s ease-in-out;
}
.header.sticked{
  height: 80px;
  padding: 6px 0;
}
.header.sticked .logoDiv img{
  width: 230px;
}
.container-fluid{
  height: 100%;
}
.header :deep(.mobile-nav-toggle){
  top: 46px;
  transition: top 0.25s ease-in-out;
}
.header.sticked :deep(.mobile-nav-toggle){
  top: 26px;
}
@media (max-width: 1279px){
  .logoDiv img{
    width: 190px;
  }
  .header.sticked .logoDiv img{
    width: 190px;
  }
  .globalLogoLink{
    margin-right: 48px;
  }
}
@media (max-width: 380px){
  .globalLogoLink{
    display: none;
  }
}
</style>
